export enum PaymentType {
  SinglePayment = "singlePayment",
  SplitPayment = "splitPayment",
}
